import { type App } from 'vue'
import AppButton from './app-button.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppInput from './app-input.vue'
import AppInputPassword from './app-input-password.vue'
import AppLoadingDot from './app-loading-dot.vue'
import AppNotice from './app-notice.vue'
import AppRouterView from './app-router-view.vue'
import AppSearch from './app-search.vue'
import AppSelect from './app-select.vue'
import AppSubmit from './app-submit.vue'
import AppTable from './app-table.vue'
import FaIcon from './fa-icon.vue'
import Modal from './modal'

export default {
  install (app: App) {
    app.component('AppButton', AppButton)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppInput', AppInput)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppLoadingDot', AppLoadingDot)
    app.component('AppNotice', AppNotice)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSearch', AppSearch)
    app.component('AppSelect', AppSelect)
    app.component('AppSubmit', AppSubmit)
    app.component('AppTable', AppTable)
    app.component('FaIcon', FaIcon)
    app.use(Modal)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppButton: typeof AppButton,
    AppErrorMsg: typeof AppErrorMsg,
    AppInput: typeof AppInput,
    AppInputPassword: typeof AppInputPassword,
    AppLoadingDot: typeof AppLoadingDot,
    AppNotice: typeof AppNotice,
    AppRouterView: typeof AppRouterView,
    AppSearch: typeof AppSearch,
    AppSelect: typeof AppSelect,
    AppSubmit: typeof AppSubmit,
    AppTable: typeof AppTable,
    FaIcon: typeof FaIcon,
  }
}
